import React from "react";
import { useSelector } from "react-redux";

//Componentes adicionales
import { AALLayout } from "../../components/AALLayout";
import { TitlePage } from "../../components/TitlePage";

//Farm
import Razas from "../../components/Farm/Razas";
import Categorias from "../../components/Farm/Categorias";
import Campos from "../../components/Farm/Campos";
import TiposVacuna from "../../components/Farm/TiposVacuna";
import TiposAntipara from "../../components/Farm/TiposAntiPara";
import CausasMuerte from "../../components/Farm/CausasMuerte";
import MaestroProveedores from "../../components/Farm/MaestroProveedores";
import TiposActividad from "../../components/Farm/TiposActividad";

// Cajas y Bancos
import CjbCuentas from "../../components/Farm/CjbCuentas";
import CjbConceptos from "../../components/Farm/CjbConceptos";

//Configuracion
//import { Opciones } from "../../components/Maestros/Configuracion/Opciones";
//import { TipoUsuarios } from "../../components/Maestros/Configuracion/TipoUsuarios";

/**
 * MaestrosPage para cargar los componentes validando el currentComponent del State
 */
export default function Maestros() {
  const currentComponent = useSelector(
    (state) => state.currentComponent.currentComponent
  );

  function loadComponent(currentComponent) {
    switch (currentComponent.opcion) {
      case "FrmRazas":
        return <Razas />;
      case "FrmCategorias":
        return <Categorias />;
      case "FrmCampos":
        return <Campos />;
      case "FrmVacunas":
        return <TiposVacuna />;
      case "FrmAntipara":
        return <TiposAntipara />;
      case "FrmCausas":
        return <CausasMuerte />;
      case "FrmProvee":
        return <MaestroProveedores />;
      case "FrmActividad":
        return <TiposActividad />;
      case "CjbCuentas":
        return <CjbCuentas />
      case "CjbConceptos":
        return <CjbConceptos />
      default:
        return <h2>No hay maestro definido</h2>;
    }
  }

  return (
    <AALLayout>
      <TitlePage title="ABM Maestros" />
      {loadComponent(currentComponent)}
    </AALLayout>
  );
}
